$(document).ready(function () {
    $('.js-sidebar-content').nlmkJsSidebar();
});



(function( $ ){
    $.fn.nlmkJsSidebar = function(selector) {
        //пересоздаём сайдбарное меню на основе заголовков внутри страницы

        if (this.length) {
            const header = $('.main > .layout > .layout__main > h1:first');
            const blocks = $(this).find('h1, h2, h3');
            const arBlocks = $.merge(header, blocks);

            const ulSidebar = $('.main > .layout > .layout__aside .side-nav');
            const nanoSidebar = $('.main > .layout > .layout__aside .layout__aside-inner.nano');
            const prevUrl = $(this).data('root-url');
            const prevName = $(this).data('root-name');
            const arData = $(this).data('content');

            let jsSidebar = [];

            $(ulSidebar).html('');
            if (typeof prevUrl !== "undefined" && typeof prevName !== "undefined") {
                $(ulSidebar).append('<li class="side-nav__header"><a href="' + prevUrl + '" class="side-nav__header-link"><svg height="6" width="18" class="svg-symbol svg-symbol--arrow-short-left"><use xlink:href="#svg-symbol--arrow-short-left"></use></svg><span>' + prevName + '</span></a></li>');
            }

            let firstClass = ' side-nav__item--head';

            if (typeof arData !== "undefined") {  /* контент из data со ссылками во вне */
                $.each(arData, function(i, e) {
                    $(ulSidebar).append('<li class="side-nav__item js-sidebar-link' + firstClass + '"><a href="' + e['LINK'] + '" class="side-nav__link">' + e['NAME'] + '</a></li>');
                    firstClass = '';
                });
            } else {  /* контент со страницы */
                $.each(arBlocks, function(i, e) {
                    let strText = $(e).text();
                    jsSidebar[i] = {
                        'el': $(e),
                    };

                    $(e).addClass('js-sidebar-target-' + i);
                    $(ulSidebar).append('<li class="side-nav__item js-sidebar-link' + firstClass + '" data-target="' + i + '"><span class="side-nav__link">' + strText + '</span></li>');
                    firstClass = '';
                }); 
            }

            $(nanoSidebar).nanoScroller();

            $(ulSidebar).on('click', '.js-sidebar-link', function(e){
                let i = $(this).data('target');

                if (typeof i !== "undefined") {
                    if (jsSidebar[i]) {
                        scrollBefore(jsSidebar[i]['el']);
                    }
                }
            });

            $(window).scroll(function() {
                sidebarScroll();
            });

            $(document).ready(function() { 
                sidebarScroll();
            });

            function sidebarScroll() {
                let wt = $(window).scrollTop();           
                let selected = false;

                $.each(jsSidebar, function(i, e) {
                    let et = $(jsSidebar[i]['el']).offset().top;
                    let eh = $(jsSidebar[i]['el']).outerHeight();
                    if (wt + eh < et && selected === false) {
                        selected = i;
                    }
                });

                if (selected !== false) {
                    sidebarSelect(selected);
                }
            }

            function scrollBefore($el) {
                $('html, body').stop().animate({
                    scrollTop: $el.offset().top - (window.innerWidth < 1024 ? 30 : $('.head__bottom').innerHeight() + 50)
                }, 700);
            }

            function sidebarSelect(i) {
                $(ulSidebar).find('.js-sidebar-link').removeClass('active');
                $(ulSidebar).find('.js-sidebar-link[data-target="' + i + '"]').addClass('active');
            }
        }

       
    }; 
})(jQuery);







// WEBPACK FOOTER //
// ./js/main/module/js-sidebar.js